import type { Translator } from '@porotutu/i18n'
import { type ApiError, fieldErrors } from '@porotutu/react/errors'
import type {
  FieldErrors,
  FieldPath,
  FieldValues,
  GlobalError,
  UseFormSetError,
} from 'react-hook-form'
import { messageOf } from './stops'

const formPath = (path: string) => (path === 'base' ? 'root' : path.replaceAll('/', '.'))

export function applyFailures<T extends FieldValues>(
  error: ApiError | null,
  setError: UseFormSetError<T>,
  t: Translator,
): void {
  const decoded = fieldErrors(error, t)
  const paths = Object.keys(decoded)

  if (paths.length > 0) {
    paths.forEach((path, index) => {
      const field = formPath(path)

      setError(
        field as FieldPath<T>,
        { message: decoded[path] },
        { shouldFocus: index === 0 && field !== 'root' },
      )
    })

    return
  }

  if (error?.status === 409) return

  setError('root' as FieldPath<T>, { message: messageOf(t, error?.status) })
}

export function rootMessage<T extends FieldValues>(errors: FieldErrors<T>): string | undefined {
  const root: GlobalError | undefined = errors.root

  return root?.message
}
